<div class="project-link">
  For more information on the EuroFAANG project, please visit link: <a href="https://eurofaang.eu/" target='_blank'>
  EuroFAANG </a>
</div>
<div>
  <div class="paragraph">
    EuroFAANG is a concept development and conceptualization project for a European Functional Annotation of ANimal
    Genomes infrastructure to realise the full potential of genotype to phenotype (G2P) research across species,
    breeds and populations of farmed animal species in Europe. To achieve accurate G2P predictions, it is necessary to
    be able to refine and characterise highly complex traits as sets of intermediate informative phenotypes along the
    entire cascade from genome to cell, organism, environment, population and across different environments. The goal
    of the EuroFAANG infrastructure project is to develop concepts for streamlining the use of interdisciplinary
    capabilities for G2P research in terrestrial and aquatic farmed animals and to establish models for transnational
    access to the required wide portfolio of relevant facilities, expertise and knowledge to European stakeholders.
    This will address the need to bring together national facilities at the pan-European level in the field of animal
    genetic resources, phenotyping and breeding, and animal health, which was identified as a gap in the infrastructure
    landscape by the 2021 ESFRI Roadmap. The proposal builds on the foundation provided by the six current H2020
    EuroFAANG projects, AQUA-FAANG, BovReg, GENE-SWitCH, GEroIMO, HOLORUMINANT and RUMIGEN, and connects with existing
    infrastructures for data management and animal agriculture in the European research infrastructure landscape.
    The six institutions and organisations currently developing the EuroFAANG infrastructure concept have comprehensive
    expertise in fundamental and applied farmed animal science and consolidated established connections to European
    stakeholders in farmed animal science. The outcomes of this project will lead to better alignment of the
    development of the research infrastructures landscape for the advancement of excellent farmed animal science and
    frontier G2P research in Europe and globally.
  </div>

  <div class="img-center">
    <a>
      <img [src]="imgUrl('project-desc-2.png')" alt="EuroFAANG"/>
    </a>
  </div>

  <div class="projectSelection">
    Select project(s) data to display in tables:
    <mat-form-field>
      <mat-label>Select project(s):</mat-label>
      <mat-select [formControl]="projects" multiple (selectionChange)="checkSelectedProjects($event.value)" #select required>
        @for (project of projectList; track project) {
          <mat-option [value]="project">{{project}}</mat-option>
        }
      </mat-select>
      @if (projects['status'] === 'INVALID') {
        <mat-error>
          You need to select at least one project
        </mat-error>
      }
    </mat-form-field>
  </div>


  <app-ensembl-annotation [projectArr]="projects['value']" parentComponent="eurofaangMainPage"></app-ensembl-annotation>


  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="publication"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Publication table...
  } @error {
    Failed to load Publication table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="dataset"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Dataset table...
  } @error {
    Failed to load Dataset table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="file" download_key="url"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading File table...
  } @error {
    Failed to load File table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="organism"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Organism table...
  } @error {
    Failed to load Organism table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="specimen"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Specimen table...
  } @error {
    Failed to load Specimen table!
  }

  <!-- Related Protocols -->
  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="protocolsamples"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Protocol Samples table...
  } @error {
    Failed to load Protocol Samples table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="protocolfiles"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Protocol Files table...
  } @error {
    Failed to load Protocol Files table!
  }

  @defer (when !projectSelectionErr) {
    <app-portal-data-table data_type="protocolanalysis"
                           [project]="projects['value']"></app-portal-data-table>
  } @loading {
    Loading Protocol Analysis table...
  } @error {
    Failed to load Protocol Analysis table!
  }
</div>



